import { Row, Table } from 'antd';
import { useState } from 'react';
import { useAppDispatch } from '../../../../app/hooks';
import { setModal } from '../../../../common/slices/commonSlice';
import { perProps } from '../../../../common/types/commonTypes';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import { loadingIndicator } from '../../../../components/common/spinner/LoadingIndicator';
import { useGetAllAirlinesWithPaginationQuery } from '../Endpoints/airlineEndpoints';
import { AirlineDataType } from '../types/AirlinesTypes';
import { airlinesColumns } from '../utils/utils';

const Airline = ({ permission }: perProps) => {
  const dispatch = useAppDispatch();
  const [editInfo, setEditInfo] = useState<AirlineDataType | null>(null);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
  });

  const handlePaginationChange = (current: number, pageSize: number) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      current,
      pageSize,
    }));
  };

  const showModal = () => {
    dispatch(setModal(true));
  };

  const {
    isLoading,
    data: airline,
    isFetching,
    refetch,
  } = useGetAllAirlinesWithPaginationQuery(pagination, {
    selectFromResult: (cache) => {
      const data = cache.data?.data;
      const count = cache.data?.count;

      const dataToReturn: AirlineDataType[] = [];
      const airLineNameList: string[] = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          airLineNameList.push(element.airline_name);
          dataToReturn.push({
            ...element,
            key: i + 1,
          });
        }
      }
      return { ...cache, data: { dataToReturn, airLineNameList, count } };
    },
  });

  return (
    <div>
      <BreadCrumb
        arrOfOption={['Configuration', 'Airline']}
        refetch={refetch}
        reloaderSize='small'
      />
      {/* <CommonTableHeader
        width
        align
        modalTitle={editInfo ? 'Edit Airline' : 'Add New Airline'}
        title='Airline'
        permission={permission?.['create:any']}
        button_text='Add New Airline'
        element={
          editInfo ? (
            <EditAirlineModal
              info={editInfo}
              airLineNameList={airline.airLineNameList}
              setNull={setEditInfo}
            />
          ) : (
            <AddNewAirline airLineNameList={airline.airLineNameList} />
          )
        }
        setNull={setEditInfo}
      /> */}
      <Row justify={'center'}>
        <Table
          size='small'
          style={{ width: 900 }}
          pagination={
            airline?.count !== undefined && airline?.count < 20
              ? false
              : {
                ...pagination,
                total: airline?.count,
                showSizeChanger: true,
                pageSizeOptions: ['50', '100', '200', '500'],
                onChange: handlePaginationChange,
              }
          }
          columns={airlinesColumns({
            setEditInfo,
            showModal,
            permission,
            pagination,
          })}
          dataSource={airline.dataToReturn}
          scroll={{ x: true }}
          loading={{
            spinning: isLoading || isFetching,
            indicator: loadingIndicator,
          }}
        />
      </Row>
    </div>
  );
};

export default Airline;
